import { createSlice } from "@reduxjs/toolkit";

const initialState = { 
  user_data:[],
  subscription_status:false
 
};
const offlinePatientReducer = createSlice({
  name: "offlinePatientReducer",
  initialState,
  reducers: {
        addNewPatientData(state,action){
                state.user_data=action.payload
            },
        addSubscriptionStatus(state,action){
          state.subscription_status=action.payload
        }
        }
   
});
export const { addNewPatientData,addSubscriptionStatus} = offlinePatientReducer.actions;
export default offlinePatientReducer.reducer;
